import React, { useRef, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const StepOtp = ({
  otp,
  timer,
  handleOtpChange,
  resendOtp,
  handleVerify,
  loading,
}) => {
  const [error, setError] = useState(false);
  const inputsRef = useRef([]);

  const focusNext = (index) => {
    if (index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const focusPrev = (index) => {
    if (index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const onChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      handleOtpChange(index, value);
      if (value !== "") {
        focusNext(index);
      }
      setError(false);
    }
  };

  const onKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index]) {
      focusPrev(index);
    }
  };

  const handleSubmit = () => {
    const isValid = otp.every((digit) => digit !== "");
    if (isValid) {
      handleVerify();
    } else {
      setError(true);
    }
  };

  return (
    <>
      <Box textAlign="center" mb={1}>
        <LockIcon fontSize="large" color="primary" />
      </Box>
      <h2>Enter the OTP</h2>

      <Box display="flex" justifyContent="center" gap={2} my={2}>
        {otp.map((digit, i) => (
          <TextField
            size="small"
            key={i}
            id={`otp-${i}`}
            value={digit}
            onChange={(e) => onChange(i, e.target.value)}
            onKeyDown={(e) => onKeyDown(e, i)}
            error={error && digit === ""}
            inputRef={(el) => (inputsRef.current[i] = el)}
            inputProps={{
              maxLength: 1,
              style: { textAlign: "center", fontSize: "20px" },
            }}
            sx={{ width: 60 }}
          />
        ))}
      </Box>

      {error && (
        <Typography variant="caption" color="error">
          Please enter all 6 digits
        </Typography>
      )}

      <Typography variant="caption" display="block" sx={{ mt: 1 }}>
        {timer > 0 ? (
          <>
            Resend OTP in{" "}
            <strong>00:{timer.toString().padStart(2, "0")}</strong>
          </>
        ) : (
          <Button onClick={resendOtp}>Resend OTP</Button>
        )}
      </Typography>

      <Button
        variant="contained"
        fullWidth
        onClick={handleSubmit}
        sx={{ mt: 2 }}
      >
        {loading ? "Loading..." : "   Verify"}
      </Button>
    </>
  );
};

export default StepOtp;
